/** Notify Inventory Changelog to refetch after count close (or similar posts). */

export const INVENTORY_CHANGELOG_REFRESH_EVENT = "mfg:inventory-changelog-refresh";

export function dispatchInventoryChangelogRefresh(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(INVENTORY_CHANGELOG_REFRESH_EVENT));
}
